import React from 'react';
import { Container, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router-dom';
import ComponentScraper from './ComponentScraper';

const StatusBar = ({ runningJobs, runningPipelines, lastRefreshed, reportDate, filteredPipelines }) => {
  // Check if we're in development mode to show developer tools
  const isDevelopment = process.env.NODE_ENV === 'development';
  const location = useLocation();
  const isReportsPage = location.pathname === '/reports';
  
  return (
    <div className="status-bar">
      <Container>
        <div className="status-container">
          <div className="status-left">
            <span className="status-item">
              <FontAwesomeIcon icon="fa-solid fa-circle-play" />
              <strong>Running Jobs:</strong> {runningJobs}
            </span>
            <span className="status-item">
              <FontAwesomeIcon icon="fa-solid fa-circle-play" />
              <strong>Running Pipelines:</strong> {runningPipelines}
            </span>
            
            {/* Developer tools - only shown in development mode */}
            {isDevelopment && (
              <span className="status-item developer-tools">
                <ComponentScraper />
              </span>
            )}
          </div>
          <div className="status-right">
            {lastRefreshed && (
              <span className="status-item">
                <FontAwesomeIcon icon="fa-regular fa-clock" />
                <strong>Last updated:</strong> {lastRefreshed.toLocaleTimeString()}
              </span>
            )}
          </div>
        </div>
        
        {/* Reports alert - only shown on reports page */}
        {isReportsPage && reportDate && (
          <Alert variant="info" className="mt-2 py-1 px-2" style={{ fontSize: '0.85rem' }}>
            {filteredPipelines.length === 0 
              ? `No scheduled pipelines found for ${reportDate.format('MMM D, YYYY')}`
              : filteredPipelines.length === 1
                ? `Displaying 1 scheduled pipeline from ${reportDate.format('MMM D, YYYY')}`
                : `Displaying ${filteredPipelines.length} scheduled pipelines from ${reportDate.format('MMM D, YYYY')}`
            }
          </Alert>
        )}
      </Container>
    </div>
  );
};

export default StatusBar; 